import { UserRoleType } from "../../../types/admin/User";
import { isType } from "../../enumChecker";

export const canRoleView = (types: UserRoleType[]) =>
  isUserRoletype(types, "REGISTRI_HALDUR", "ADMINISTRAATOR", "KVY_HALDUR", "JK_KOORDINAATOR");

export const canRoleViewAlerts = (types: UserRoleType[]) => isUserRoletype(types, "REGISTRI_HALDUR");

export const canRoleViewThiAndVat = (types: UserRoleType[]) => isUserRoletype(types, "REGISTRI_HALDUR", "KVY_HALDUR");

const isUserRoletype = (types: UserRoleType[], ...matchTypes: Array<keyof typeof UserRoleType>) => {
  return types.reduce((sum, current) => sum || isType<typeof UserRoleType>(current, ...matchTypes), false);
};
